import { GroupByDimension } from '../../services/comparisonDashboardService';

export const COMPARISON_GROUP_BY_OPTIONS: { value: GroupByDimension; label: string }[] = [
  { value: 'product', label: 'Product' },
  { value: 'customer', label: 'Customer' },
  { value: 'brand', label: 'Brand' },
  { value: 'category', label: 'Category' },
  { value: 'sales_rep', label: 'Sales Rep' },
  { value: 'territory', label: 'Territory' },
];

/** Executive Breakdown opens on Category so the first fetch is a short list, not every product×customer. */
export const EXECUTIVE_BREAKDOWN_DEFAULT_GROUP_BY: GroupByDimension = 'category';

export const COMPARISON_SECONDARY_LABEL: Record<GroupByDimension, string> = {
  product: 'Customer',
  customer: 'Product',
  brand: 'Customer',
  category: 'Product',
  sales_rep: 'Product',
  territory: 'Product',
};

export const COMPARISON_METRIC_COLUMNS = [
  { key: 'revenue', label: 'Revenue', format: 'currency' as const },
  { key: 'qty', label: 'Qty', format: 'number' as const },
  { key: 'avg_sale', label: 'Avg Sale', format: 'currency' as const },
  { key: 'min_sale', label: 'Min Sale', format: 'currency' as const },
  { key: 'max_sale', label: 'Max Sale', format: 'currency' as const },
  { key: 'avg_price', label: 'Avg Price', format: 'currency' as const },
  { key: 'min_price', label: 'Min Price', format: 'currency' as const },
  { key: 'max_price', label: 'Max Price', format: 'currency' as const },
] as const;

/** Customer activity for every product in the selected dates. `title` is the hover text before the dates. */
export const CUSTOMER_ACTIVITY_COLUMNS = [
  {
    key: 'customer_total_sales',
    label: 'Total Sales',
    format: 'currency' as const,
    title: 'Sales of all products',
  },
  {
    key: 'customer_order_count',
    label: 'Orders',
    format: 'number' as const,
    title: 'Number of orders',
  },
] as const;

/** Hover text for a customer-activity column, using the dates on the report. */
export function customer_activity_column_title(
  key: string,
  filters?: { start_date?: string; end_date?: string }
): string | undefined {
  const column = CUSTOMER_ACTIVITY_COLUMNS.find((col) => col.key === key);
  if (!column) return undefined;
  if (filters?.start_date && filters?.end_date) {
    return `${column.title} from ${filters.start_date} to ${filters.end_date}`;
  }
  return `${column.title} in the selected date range`;
}

export function formatComparisonMetricValue(
  value: number | null | undefined,
  format: string
): string {
  if (value == null || Number.isNaN(Number(value))) {
    return format === 'currency' ? '$0.00' : '0';
  }
  if (format === 'currency') {
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
}
